import React, { Component } from 'react';
import {
  PageHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Home.css';
import { API, Auth } from 'aws-amplify';
import { CognitoUser } from 'amazon-cognito-identity-js';
import LoaderButton from '../components/LoaderButton';
import EstimatorNavBar from '../components/EstimatorNavBar';
import { HashLink } from 'react-router-hash-link';

export default class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      username: '',
      estimates: []
    };
  }

  /* =============================== CODE FOR DELETING ESTIMATES =============================== */

  handleDelete(estimateId, estimateName, e) {
    e.preventDefault();

    const confirmed = window.confirm(
      'Are you sure you want to delete ' + estimateName + '?'
    );

    if (!confirmed) {
      return;
    }

    try {
      this.deleteEstimate(estimateId);
      window.setTimeout(() => {
        window.location.reload();
      }, 500);
    } catch (e) {
      alert(e);
    }
  }

  deleteEstimate(estimateId) {
    return API.del('va-estimator', `/va-estimator/` + estimateId);
  }

  /* =============================== END OF CODE FOR DELETING ESTIMATES =============================== */

  handleDeleteAccount(e) {
    e.preventDefault();

    const confirmed = window.confirm(
      'Are you sure you want to delete your account? All of your estimates will also be deleted.'
    );

    if (!confirmed) {
      return;
    }

    this.onRemoveAccount();
  }

  onRemoveAccount() {
    //first try to cancel their stripe subscriptions, if any
    API.post('va-estimator', '/va-estimator/unsubscribe', {
      body: {
        email: this.state.username
      }
    })
      .then(result => {
        console.log('Successfully unsubscribed in Stripe.');
        //then delete their cognito account
        Auth.currentAuthenticatedUser()
          .then(
            (user: CognitoUser) =>
              new Promise((resolve, reject) => {
                this.state.estimates.forEach(e => {
                  this.deleteEstimate(e.estimateId);
                });

                user.deleteUser(error => {
                  if (error) {
                    return reject(error);
                  }
                  if (this.props.onSessionChange) {
                    this.props.onSessionChange();
                  }
                  document.location.href = '/login';

                  resolve();
                });
              })
          )
          .catch(this.onError);
      })
      .catch(error => {
        console.error('Error unsubscribing in Stripe.');
        console.error(error);
        return;
      });
  }

  getUsername = async event => {
    try {
      await Auth.currentAuthenticatedUser().then(data =>
        this.setState({ username: data.attributes.email })
      );
    } catch (e) {
      alert(e);
    }
  };

  async componentDidMount() {
    if (!this.props.isAuthenticated) {
      return;
    }
    if (this.props.isAuthenticated) {
      this.getUsername();
    }
    try {
      const estimates = await this.estimates();
      this.setState({ estimates });
    } catch (e) {
      alert(e);
    }

    this.setState({ isLoading: false });
  }

  estimates() {
    return API.get('va-estimator', '/va-estimator');
  }

  renderEstimatesList(estimates) {
    return [{}].concat(estimates).map(
      (estimate, i) =>
        i !== 0 ? (
          <Row className="estimate-row" key={estimate.estimateId}>
            <Col xs={12} md={10}>
              <ListGroupItem
                href={`/estimates/${estimate.estimateId}`}
                onClick={this.handleEstimateClick}
                header={estimate.estimateName.trim().split('\n')[0]}>
                {'Created: ' + new Date(estimate.createdAt).toLocaleString()}
              </ListGroupItem>
            </Col>
            <Col xs={12} md={2} className="delete-container">
              <LoaderButton
                block
                bsStyle="danger"
                isLoading={false}
                onClick={e =>
                  this.handleDelete(
                    estimate.estimateId,
                    estimate.estimateName,
                    e
                  )
                }
                text="Delete"
                loadingText="Deleting…"
              />
            </Col>
          </Row>
        ) : (
          <Row className="estimate-row" key="new">
            <Col xs={12} md={10}>
              <ListGroupItem
                href="/estimates/new"
                onClick={this.handleEstimateClick}>
                <h4>
                  <b>{'\uFF0B'}</b> Create a new estimate
                </h4>
              </ListGroupItem>
            </Col>
            <Col xs={12} md={2} className="delete-container" />
          </Row>
        )
    );
  }

  handleEstimateClick = event => {
    event.preventDefault();
    this.props.history.push(event.currentTarget.getAttribute('href'));
  };

  renderLander() {
    return (
      <div className="lander">
        <h1>Digimasters VA Estimator</h1>
        <p>A project estimation tool for visual analytics applications.</p>
        <p>
          To get started, please <Link to="/register">register</Link> a new
          account or <Link to="/login">login</Link> to an existing account.
        </p>
        <p>
          If you need any help, feel free to watch our{' '}
          <HashLink to="/blog#tutorial">tutorial video</HashLink>.
        </p>
      </div>
    );
  }

  renderPageHeader() {
    if (this.state.isLoading) {
      return <PageHeader>Loading...</PageHeader>;
    } else {
      return <PageHeader>Your Estimates</PageHeader>;
    }
  }

  renderEstimates() {
    return (
      <div className="estimates">
        {/* <PageHeader>Your Estimates</PageHeader> */}

        {this.renderPageHeader()}
        <p>
          Unsure where to start? Take a look at our{' '}
          <HashLink to="/blog#tutorial">tutorial video</HashLink>.
        </p>
        <ListGroup>
          {!this.state.isLoading &&
            this.renderEstimatesList(this.state.estimates)}
        </ListGroup>
        <Row>
          <Col xs={6} md={3}>
            <LoaderButton
              block
              isLoading={false}
              onClick={e => this.handleDeleteAccount(e)}
              text="Delete Account"
              loadingText="Deleting…"
            />
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    return (
      <div>
        <EstimatorNavBar
          isAuthenticated={this.props.isAuthenticated}
          appLogout={this.props.appLogout}
          accountType={this.props.accountType}
        />
        <div className="Home">
          {this.props.isAuthenticated
            ? this.renderEstimates()
            : this.renderLander()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Home.js